/**
 * Email Keyboard Controller — stub.
 *
 * Keyboard shortcuts are now handled by EmailKeyboardHandler (a pure JS module)
 * registered inside email_controller.js. This controller exists only to prevent
 * Stimulus from logging "unknown controller" warnings if any old ERB partials
 * still reference it.
 *
 * All keyboard logic has been moved to:
 *   app/javascript/modules/email/email-keyboard.js
 */

import { Controller } from '@hotwired/stimulus'

export default class extends Controller {}
